export type IEnv = "local" | "development" | "production";

export type IConfig = {
  apiUrl: string;
  env: IEnv;
  googleClientId?: string;
};

export const CONFIG: IConfig = {
  // In local environments, SSR vs client-side URLs are different as one is
  // running inside Docker and the other is not. This works because only NEXT_PUBLIC_
  // prefixed env variables make it to the browser
  apiUrl:
    process.env.API_SERVICE_URL ||
    process.env.NEXT_PUBLIC_API_SERVICE_URL ||
    "http://34.136.46.31:8000",
  env: (process.env.NEXT_PUBLIC_ENV || "production") as IEnv,
  googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
};

// UI and configuration constants
export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  XXL: 1536,
} as const;

export const CACHE_CONFIG = {
  PRICE_HISTORY_TTL: 5 * 60 * 1000, // 5 minutes
  DEFAULT_CACHE_CLEANUP_INTERVAL: 10 * 60 * 1000, // 10 minutes
} as const;

export const UI_CONFIG = {
  CHART_LOAD_DELAY: 100, // ms delay before loading charts
  RESIZE_DEBOUNCE_DELAY: 100, // ms debounce for resize events
} as const;
